import type { OverviewAnalysisResult } from "../../modules/overviewAnalysis/types";

const compactFinding = (text: string): string => {
 // Keep the highest-priority finding's actual entity and numbers. Shorten only
 // known wording from the rules; unknown findings keep their original meaning.
 const technical = text.match(/^В общей статистике повторяются технические ошибки: ([^;]+?)(?:;|\. Есть|\.$)/);
 if (technical) {
  const example = technical[1].replace(/ — ([\d\s.,]+)$/, (_, value: string) => {
   const count = Number(value.replace(/\s/g, "").replace(",", "."));
   const form = new Intl.PluralRules("ru").select(count);
   return ` — ${value} ${form === "one" ? "ошибка" : form === "few" ? "ошибки" : "ошибок"}`;
  });
  return example.charAt(0).toUpperCase() + example.slice(1);
 }
 return text
  .replace(/Успешно проходят ([\d,.]+)% платежей/g, "Проходимость $1%")
  .replace(/успешно проходят ([\d,.]+)% платежей/g, "проходимость $1%")
  .replace(/ по сравнению с предыдущим периодом/g, "")
  .replace(/, как и в предыдущем периоде/g, ", как и раньше")
  .replace(/ \([\d\s.,]+ попыток\)/g, "")
  .replace(/\. Устойчивость отклонения пока не подтверждена\./g, " (устойчивость не подтверждена)")
  .replace(/\. Разница с прошлым периодом пока не подтверждена статистически\./g, " (разница статистически не подтверждена)")
  .replace(/\.$/, "");
};

export const overviewCompactSummary = (result: OverviewAnalysisResult): string => {
 if (result.status === "insufficient_data") return result.summary || "Оценка пока недоступна";
 if (result.status === "ok") return result.observations?.length ? "Значимых отклонений нет · есть наблюдение" : "Значимых отклонений нет";
 const first = result.issues[0];
 if (!first) return result.summary || (result.status === "critical" ? "Есть серьёзные проблемы" : "Требует внимания");
 const remaining = result.issues.length - 1;
 const noun = remaining % 10 === 1 && remaining % 100 !== 11 ? "проблема" : remaining % 10 >= 2 && remaining % 10 <= 4 && !(remaining % 100 >= 12 && remaining % 100 <= 14) ? "проблемы" : "проблем";
 return `${result.status === "critical" ? "Критично · " : ""}${compactFinding(first)}${remaining ? ` · ещё ${remaining} ${noun}` : ""}`;
};
